// Chart types
export const AMOUNT_CHART = 1
export const ACTUAL_EXPECTED_CHART = 2
export const OXYGEN_CHART = 3
export const OBSERVED_EXPECTED_CHART = 4
export const DAYS_LEFT_FEEDING_CHART = 5

// Statistic types
export const COUNT_SUMMARY = 1
export const TOTAL_SEA_LICE = 2
export const JUVENILE = 3
export const MOBILE_ADULTS = 4
export const GRAVID_FEMALES = 5

// Colors
export const DARK_GREEN = '#739A49'
export const GREEN = '#95CD5A'
export const YELLOW = '#F7C22F'
export const RED = '#DD5959'
export const DEFAULT_CHART_COLOR = '#ccc'
export const CHART_COLORS = [
  '#33691E',
  '#FFC107',
  '#FB404B',
  '#9368E9',
  '#87CB16',
  '#1DC7EA',
  '#3b5998',
  '#607D8B',
  '#B8860B',
  '#EE82EE',
]
export const SILO_CHART_COLORS = [
  '#546e7a',
  '#80a9bb',
  '#4dbdd5',
  '#688291',
  '#458fb1',
  '#1c849a',
]
export const TOTAL_BAR_CHART_COLOR_RGBA = 'rgba(84, 110, 122, .7)'
export const DEFAULT_CHART_COLOR_RGBA = 'rgba(84, 110, 122, 1)'
export const DEFAULT_CHART_COLOR_RGBA_HOVER = 'rgba(84, 110, 122, 0.5)'

// Result types
export const HIGH_RESULT = 120
export const GOOD_RESULT = 75
export const MIDDLE_RESULT = 50
export const LOW_RESULT = 25
